module.exports = __webpack_public_path__ + "img/ui-project-1.016cdb23.jpg";